module.exports = __webpack_public_path__ + "img/member2.5cebd3e5.svg";